/**
 * @file
 * Add a html dialog box.
 */
var $ = require('jquery');

// Classes that we want to use.
var stopScroll = 'disable-scrolling';

// Element selectors.
var scrollEl = 'body';

// Events to control scroll.
var scrollEvents = ['wheel', 'mousewheel', 'touchmove', 'keydown'].map(function(e) {
  return e + '.stopScroll';
}).join(' ');

// Ids of dialog elements.
var selectors = {
  wrapperId: 'e-confirm-wrapper',
  containerId: 'e-confirm-content',
  titleContainerId: 'e-confirm-title',
  messageContainerId: 'e-confirm-message',
  actionContainerId: 'e-confirm-actions',
  cancelButtonId: 'e-confirm-cancel',
  windowCloseClass: 'dialog-icon-close',
  confirmButtonId: 'e-confirm-confirm'
};

// Main wrapper of the dialog.
var dialogWrapper =
  '<div id="' + selectors.wrapperId + '" style="display: none">' +
  '<div class="popup-dialog-cover"></div>' +
  '</div>';
var $dialogWrapper = $(dialogWrapper);

// Main body of the dialog.
var dialogBody =
  '<div id="' + selectors.containerId + '" class="popup-dialog-content">' +
  '<div id="' + selectors.messageContainerId + '" class="popup-dialog-message dialog-item"></div>' +
  '<div id="' + selectors.actionContainerId + '" class="dialog-item form-actions">' +
  '<input type="submit" class="form-submit confirm-button" id="' + selectors.confirmButtonId + '" name="op" value="Confirm">' +
  '<input type="submit" class="form-submit cancel-button" id="' + selectors.cancelButtonId + '" name="op" value="Cancel">' +
  '</div>' +
  '</div>';
var $dialogBody = $(dialogBody);

// Optional title of the dialog.
var dialogTitle = '<div id="' + selectors.titleContainerId + '" class="popup-dialog-title dialog-item" />';
var $dialogTitle = $(dialogTitle);

// Declare a new prototype for equiem_confirm (eConfirm).
$.fn.eConfirm = function(options) {
  if (typeof options != 'object') {
    return;
  }

  this.off('click.eConfirm').on('click.eConfirm', function (e) {
    e.preventDefault();

    var newOptions = $.extend(true, {}, {
      trigger: $(this)
    }, options);

    $.eConfirm(newOptions, e);
  });

  return this;
};

// Controller of the dialog box.
$.eConfirm = function(options, e) {
  var $wrapper = $('#' + selectors.wrapperId);
  if ($wrapper.length != 1 || $wrapper.is(':visible')) {
    return;
  }

  // Combine options from different sources.
  $.eConfirm.setOptions(options, e);

  // Make the dialog ready to display.
  $.eConfirm.prepareDialog();

  // Display the dialog.
  $.eConfirm.displayDialog();
};

// Accumulate dialog options from different sources.
$.eConfirm.setOptions = function(options, e) {
  var $trigger = ('trigger' in options) ? options.trigger : {};

  // Parse options defined with "data-" attributes
  var dataOptions = {};
  if ($trigger.length) {
    var allData = $trigger.data();
    $.each($.eConfirm.options, function(key, val) {
      if (key.toLowerCase() in allData) {
        dataOptions[key] = allData[key.toLowerCase()];
      }
    });
  }

  // Get submit function when newOptions.submitForm is true.
  var confirmCallback = null;
  var $form = ($trigger.length) ? $trigger.closest("form") : {};
  if ((options.triggerEventBack || dataOptions.triggerEventBack) && ($.type(e) == 'object') && ('target' in e) && $(e.target).length) {
    confirmCallback = function() {
      var ev = document.createEvent('MouseEvent');
      ev.confirmed = true;
      ev.initEvent('click', true, true);
      e.target.dispatchEvent(ev);
    };
  }
  else if ((options.submitForm || dataOptions.submitForm) && $form.length) {
    confirmCallback = function() {
      $form.submit();
    };
  }

  // Create an object to pass confirmCallback (if any).
  var submitOptions = {};
  if (confirmCallback) {
    submitOptions = {
      confirm: {
        callback: confirmCallback
      }
    };
  }

  // This extend defines the settings overriding ability.
  // It's a recursive extend where we're extending $.eConfirm.options.
  // The object submitOptions can bave confirm callback only and
  // the object dataOptions can't have confirm callback. So they are
  // not going to override any attribute of each other.
  // Finally, the object options can have all sort of attributes and will
  // override any previous value.
  $.extend(true, $.eConfirm.options, submitOptions, dataOptions, options);
};

// Display the dialog.
$.eConfirm.displayDialog = function() {
  $dialogWrapper.append($dialogBody);
  $dialogWrapper.show();
  $.eConfirm.stopScroll(true);
};

// Reset the dialog markup.
$.eConfirm.reset = function() {
  $dialogBody.remove();
  $dialogWrapper.hide();
  $.eConfirm.stopScroll(false);
  $dialogBody = $(dialogBody);
  $dialogTitle = $(dialogTitle);
};

// Fill up the dialog markup with expected values.
$.eConfirm.prepareDialog = function() {
  var options = $.eConfirm.options;

  // Set the title.
  if (typeof options.title == 'string' && options.title.length > 0) {
    $dialogTitle.html(options.title + '<span class="' + selectors.windowCloseClass + '"></span>');
    $dialogBody.prepend($dialogTitle);
  }

  // Set the message.
  if (typeof options.message == 'string' && options.message.length > 0) {
    $dialogBody.find('#' + selectors.messageContainerId).html(options.message);
  }

  // Set button attributes.
  $.each(['confirm', 'cancel'], function(i, el) {
    // Update button text.
    if (typeof options[el].attributes == 'object') {
      $.each(options[el].attributes, function(key, val) {
        $dialogBody.find('#' + selectors[el + 'ButtonId']).attr(key, val);
      });
    }
    // Add class.
    if (typeof options[el].class == 'object') {
      $dialogBody.find('#' + selectors[el + 'ButtonId']).addClass(options[el].class.join(' '));
    }
    // Add style.
    if (typeof options[el].style == 'object') {
      $dialogBody.find('#' + selectors[el + 'ButtonId']).css(options[el].style);
    }
  });

};

// Call the callback and reset the dialog when you press a dialog button.
$.eConfirm.submit = function(e) {
  var isConfirm = e.data;

  if (isConfirm) {
    $.eConfirm.options.confirm.callback();
  }
  else {
    $.eConfirm.options.cancel.callback();
  }

  // Reset the dialog.
  $.eConfirm.reset();
};

// Close the window after you click the close icon.
$.eConfirm.close = function(e) {
  // Reset the dialog.
  $.eConfirm.reset();
};

// On or off window scroll.
$.eConfirm.stopScroll = function(i) {
  if (i) {
    $(scrollEl).addClass(stopScroll);
    $(window).on(scrollEvents, function(e) {
      e.preventDefault();
    });
  }
  else {
    $(scrollEl).removeClass(stopScroll);
    $(window).off(scrollEvents);
  }
};

// Globally definable rules.
$.eConfirm.options = {
  /**
   * The title of the dialog box.
   *
   * @type string
   */
  title: "",

  /**
   * The main body message.
   *
   * @type string
   */
  message: "Are you sure to proceed?",

  /**
   * Trigger form submit for the form that contains triggered element.
   *
   * @type boolean
   */
  submitForm: false,

  /**
   * Trigger the triggered element original event back.
   *
   * Eg. When the user click the button id "a" and when the confirm popup,
   * then the user click confirm, it will trigger back click on button id "a"
   * again.
   *
   * @type boolean
   */
  triggerEventBack: false,

  /**
   * Confirm callback.
   *
   * @type Object
   */
  confirm: {
    class: '',
    style: {},
    attributes: {
      value: 'Confirm'
    },
    callback: function() {
      // We expect this function to be replaced by the user defined one.
    }
  },

  /**
   * Cancel callback.
   *
   * @type object
   */
  cancel: {
    class: '',
    style: {},
    attributes: {
      value: 'Cancel'
    },
    callback: function() {
      // We expect this function to be replaced by the user defined one.
    }
  }
};

// Vue component options.
export default {
  settings: {},
  event: {},
  created() {
    if ($('#' + selectors.wrapperId).length == 0) {
      $('body').append($dialogWrapper);
      $dialogWrapper.on('click.eConfirm', '#' + selectors.confirmButtonId, true, $.eConfirm.submit);
      $dialogWrapper.on('click.eConfirm', '#' + selectors.cancelButtonId, false, $.eConfirm.submit);
      $dialogWrapper.on('click.eConfirm', '.' + selectors.windowCloseClass, false, $.eConfirm.close);
    }

    if (!this.$options.el) {
      let options = this.$options.settings || {};
      let event = this.$options.event || {};

      // Only proceed if options param is an object.
      if (typeof options != 'object' || typeof event != 'object') {
        throw "Options and event have to be object";
      }

      if (!event.originalEvent || !event.originalEvent.confirmed) {
        // Stop default event actions.
        event.preventDefault();
        // If trigger is not already set, set it from the event.
        if (!('trigger' in options)) {
          $.extend(true, options, {trigger: $(event.target)});
        }
      }

      $.eConfirm(options, event);
    }
  },
  mounted () {
    $(this.$el).eConfirm(this.$options.settings);
  }
};



// WEBPACK FOOTER //
// ./app/components/molecules/popup-dialog/popup-dialog.js